import { render, staticRenderFns } from "./TheChatBot.vue?vue&type=template&id=a5cc1024&scoped=true"
import script from "./TheChatBot.vue?vue&type=script&lang=js"
export * from "./TheChatBot.vue?vue&type=script&lang=js"
import style0 from "./TheChatBot.vue?vue&type=style&index=0&id=a5cc1024&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cc1024",
  null
  
)

export default component.exports